// Generated by Melange

import * as Buhta_cabinet__KeyItemPreview from "../../../components/organisms/Admin/Keychain/KeyItemPreview.js";
import * as Buhta_cabinet__Keychain from "../../../grpc/Keychain.js";
import * as Buhta_cabinet__PageNav from "../../../components/molecules/PageNav.js";
import * as Buhta_cabinet__Search from "../../../components/molecules/Search/Search.js";
import * as Buhta_cabinet__Table2 from "../../../components/molecules/Table/Table2.js";
import * as Buhta_cabinet__Timestamp from "../../../util/Timestamp.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KeysPage(Props) {
  const match = React.useState(function () {
    
  });
  const setCurrentItemId = match[1];
  const currentItemId = match[0];
  const match$1 = React.useState(function () {
    return 1;
  });
  const setPage = match$1[1];
  const page = match$1[0];
  const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Keychain.KeyService.grid, undefined);
  const grid = match$2[0];
  const rows = typeof grid === "string" || grid.NAME !== "Data" ? /* [] */ 0 : Stdlib__List.mapi((function (i, model) {
      const o = model.org;
      const org = o !== undefined ? o : ({
          id: 0,
          country: /* COUNTRY_KAZ */ 1,
          "type'": /* ORG_TYPE_UNSPECIFIED */ 0,
          tin: "",
          name: "",
          address: ""
        });
      const time = model.issue_time;
      const issueTime = time !== undefined ? DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(time)) : "-";
      const time$1 = model.expire_time;
      const expireTime = time$1 !== undefined ? DateTime.toLocalFormat(Buhta_cabinet__Timestamp.toDateTime(time$1)) : "-";
      const time$2 = model.expire_time;
      const daysLeft = time$2 !== undefined ? DateTime.daysLeft(Buhta_cabinet__Timestamp.toDateTime(time$2)) : 0;
      const cells_0 = {
        body: String(model.id),
        style: ""
      };
      const cells_1 = {
        hd: {
          body: org.name,
          style: "col-span-2"
        },
        tl: {
          hd: {
            body: model.name,
            style: ""
          },
          tl: {
            hd: {
              body: model.key_usage,
              style: ""
            },
            tl: {
              hd: {
                body: issueTime,
                style: ""
              },
              tl: {
                hd: {
                  body: expireTime,
                  style: daysLeft < 7 ? "!text-pink-700" : (
                      daysLeft < 14 ? "!text-orange-700" : (
                          daysLeft < 30 ? "!text-yellow-700" : ""
                        )
                    )
                },
                tl: {
                  hd: {
                    body: model.valid ? "Валиден" : "Не валиден",
                    style: model.valid ? "!text-green-600" : "!text-red-600"
                  },
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      };
      const cells = {
        hd: cells_0,
        tl: cells_1
      };
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_cabinet__Table2.Row.make, {
        cells: cells,
        onClick: (function (param) {
          Curry._1(setCurrentItemId, (function (param) {
            return model.id;
          }));
        })
      }, Key);
    }), grid.VAL);
  const currentRecords = typeof grid === "string" || grid.NAME !== "Data" ? 0 : Stdlib__List.length(grid.VAL);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Search.make, {
        dispatch: match$2[1],
        page: page,
        setPage: setPage,
        searchLength: 2
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__Table2.make, {
          header: {
            hd: {
              name: "ID",
              style: ""
            },
            tl: {
              hd: {
                name: "Предприятие",
                style: "col-span-2"
              },
              tl: {
                hd: {
                  name: "Название",
                  style: ""
                },
                tl: {
                  hd: {
                    name: "Предназначение",
                    style: ""
                  },
                  tl: {
                    hd: {
                      name: "Дата выпуска",
                      style: ""
                    },
                    tl: {
                      hd: {
                        name: "Дата истечения",
                        style: ""
                      },
                      tl: {
                        hd: {
                          name: "Статус",
                          style: ""
                        },
                        tl: /* [] */ 0
                      }
                    }
                  }
                }
              }
            }
          },
          rows: rows,
          styles: "grid-cols-8"
        }),
        className: "flex-1 overflow-auto"
      }),
      JsxRuntime.jsx(Buhta_cabinet__PageNav.make, {
        page: page,
        setPage: setPage,
        currentRecords: currentRecords
      }),
      currentItemId !== undefined ? JsxRuntime.jsx(Buhta_cabinet__KeyItemPreview.make, {
          id: currentItemId,
          onClose: (function (param) {
            Curry._1(setCurrentItemId, (function (param) {
              
            }));
          })
        }) : null
    ]
  });
}

const make = KeysPage;

export {
  make,
}
/* Buhta_cabinet__KeyItemPreview Not a pure module */
